module.exports = __webpack_public_path__ + "media/images/logo_ui_column_footer-428bf13a9810ac14303d40edfeb75e41.png";